var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center f"},[_c('div',{staticClass:"flex flex-col"},[_c('BaseButton',{attrs:{"icon":"bars","flat":"","title":"Shift + Alt + X","size":"icon"},on:{"click":_vm.toggleDrawer}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }